import { render, staticRenderFns } from "./fenxi.vue?vue&type=template&id=2cad89e2&scoped=true"
import script from "./fenxi.vue?vue&type=script&lang=js"
export * from "./fenxi.vue?vue&type=script&lang=js"
import style0 from "./fenxi.vue?vue&type=style&index=0&id=2cad89e2&prod&scoped=true&lang=css"
import style1 from "./fenxi.vue?vue&type=style&index=1&id=2cad89e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad89e2",
  null
  
)

export default component.exports